module.exports = __webpack_public_path__ + "img/result_desk_lx.b82d7478.jpg";